import { useState } from "react";

import "./Sidebar.css";
import Logo from "../../assets/logo.png";

const Sidebar = () => {
  const [toggle, showMenu] = useState(false);

  return (
    <>
      <aside className={toggle ? "aside show-menu" : "aside"}>
        <a href='#home' className='nav__logo'>
          <img src={Logo} alt="Logo of William"/>
        </a>

        <nav className='nav'>
          <div className='nav__menu'>
            <ul className='nav_list'>
              <li className='nav__item'>
                <a href='#home' className='nav__link'>
                  <i className='icon-home'></i>
                </a>
              </li>

              <li className='nav__item'>
                <a href='#about' className='nav__link'>
                  <i className='icon-user-following'></i>
                </a>
              </li>

              <li className='nav__item'>
                <a href='#education' className='nav__link'>
                  <i className='icon-graduation'></i>
                </a>
              </li>

              <li className='nav__item'>
                <a href='#experience' className='nav__link'>
                  <i className='icon-briefcase'></i>
                </a>
              </li>

              <li className='nav__item'>
                <a href='#portfolio' className='nav__link'>
                  <i className='icon-layers'></i>
                </a>
              </li>

              <li className='nav__item'>
                <a href='#skills' className='nav__link'>
                  <i className='icon-target'></i>
                </a>
              </li>

              {/*
              <li className='nav__item'>
                <a href='#testimonials' className='nav__link'> 
                  <i className='icon-badge'></i>
                </a>
              </li>
              */}

              {/*
              <li className='nav__item'>
                <a href='#blogs' className='nav__link'> 
                  <i className='icon-pencil'></i>
                </a>
              </li>
              */}

              <li className='nav__item'>
                <a href='#contact' className='nav__link'>
                  <i className='icon-bubble'></i>
                </a>
              </li>
            </ul>
          </div>
        </nav>

        <div className='nav__footer'>
          <span className='copyright'>
            &copy; 2025
          </span>
        </div>
      </aside>

      <div
        className={toggle ? "nav__toggle nav__toggle-open" : "nav__toggle"}
        onClick={() => showMenu(!toggle)}
      >
        <i className="icon-menu"></i>
      </div>
    </>
  )
}

export default Sidebar